.link {
  color: var(--fg);
  text-decoration: initial;
}

.link-underline {
  color: var(--fg-lit);
  text-decoration: underline;
}

.link-nav {
  transition: color 0.5s ease-in-out;
}

@media (hover: hover) {
  .link-nav:hover {
    color: var(--fg-lit);
  }
}
